/**
 * Retrieves the runtime configuration from the global window object.
 * This configuration is loaded from the runtime-config.js file in the public folder.
 *
 * @throws {Error} If window is undefined or runConfig is not loaded
 * @returns {Record<string, string>} The runtime configuration object containing key-value pairs
 *
 * @example
 * const config = getRuntimeConfig();
 * console.log(config.BASE_URL);
 */
export const getRuntimeConfig = () => {
  if (process.env.REACT_APP_BASE_URL) {
    return {
      BASE_URL: process.env.REACT_APP_BASE_URL,
      SUB_PATH: process.env.REACT_APP_SUB_PATH || "",
      CNB_ENV: process.env.REACT_APP_CNB_ENV,
      AMPLITUDE: process.env.REACT_APP_AMPLITUDE,
      LOGDNA_INGESTION_KEY: process.env.REACT_APP_LOGDNA_INGESTION_KEY,
    };
  }

  if (typeof window === "undefined" || !window.runConfig) {
    throw new Error("Runtime config not loaded");
  }

  return window.runConfig;
};

// Add type safety
declare global {
  interface Window {
    runConfig: {
      [key: string]: string | number | boolean | object;
    };
  }
}
